import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useSocket } from '../contexts/SocketContext';

const DisconnectedBanner: React.FC = () => {
  const { connected } = useSocket();

  if (connected) return null;

  return (
    <div className="bg-red-600 text-white px-4 py-3 flex items-center justify-center gap-3 animate-fade-in">
      <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" />
      <span className="text-sm font-medium">
        Real-time connection lost &mdash; data may be stale. Reconnecting...
      </span>
      <span className="flex h-3 w-3 flex-shrink-0">
        <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-red-300 opacity-75" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-200" />
      </span>
    </div>
  );
};

export default DisconnectedBanner;
